// extracted by mini-css-extract-plugin
module.exports = {"button":"InputButton_button__3oAU7","disabled":"InputButton_disabled__BiXlm","svg":"InputButton_svg__NcfGy"};